import React, { useEffect } from 'react';

import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';

import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import { incidentRoad } from '../../../../constants/incidents.constant';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import CarHasAppeared from './CarHasappeared.component';
import Complaint from './Complaint.component';

const ComplaintValidation = () => {
  const { nextStep, sinister_body } = useSinisterDataContext();

  let robbery: { [index: string]: any } = incidentRoad.robbery;

  useEffect(() => {
    let keytodelete = null;
    robbery = incidentRoad.robbery;
    robbery.forEach((element: any, key: any) => {
      if (
        element?.title === 'Denuncia Policial' ||
        element?.title === 'Aparición del auto' ||
        element?.title === 'Daños en mi vehículo' ||
        element?.title === '¿Que te robaron?'
      ) {
        robbery.splice(key, 1);
      }
    });
    if (keytodelete) robbery.splice(keytodelete, 1);

    robbery = robbery.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));
  }, []);

  const steps = {
    hasComplain: [
      {
        title: 'Denuncia Policial',
        content: <Complaint />,
        order: 3,
      },
      {
        title: 'Aparición del auto',
        content: <CarHasAppeared />,
        order: 4,
      },
    ],
    hasNoComplain: [
      {
        title: 'Aparición del auto',
        content: <CarHasAppeared />,
        order: 3,
      },
    ],
    complaintForPartial: [
      {
        title: 'Denuncia Policial',
        content: <Complaint />,
        order: 9,
      },
    ],
  };

  const selectComplaint = (hasComplaint: boolean) => {
    robbery = incidentRoad.robbery;

    if (sinister_body?.robbery?.type === 'partial') {
      if (hasComplaint) {
        if (
          !robbery.find(
            (element: { title: any }) => element.title === 'Denuncia policial'
          )
        ) {
          steps.complaintForPartial.forEach((step) => {
            robbery.push(step);
          });
        }
      }
    } else {
      if (hasComplaint) {
        if (
          !robbery.find(
            (element: { title: any }) => element.title === 'Denuncia policial'
          )
        ) {
          steps.hasComplain.forEach((step) => {
            robbery.push(step);
          });
        } else {
          robbery.forEach((element: any, key: any) => {
            if (element.title === 'Denuncia policial') {
            }
          });
        }
      }
      if (hasComplaint === false) {
        robbery.forEach((element: any, key: any) => {
          if (element.title === 'Denuncia policial') {
            robbery.splice(key, 1);
          }
        });
        if (
          !robbery.find(
            (element: { title: any }) => element.title === 'Aparición del auto'
          )
        ) {
          steps.hasNoComplain.forEach((step) => {
            robbery.push(step);
          });
        }
      }
    }
    robbery = robbery.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));
    robbery = incidentRoad.robbery;

    nextStep();
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box my={3}>
          <Typography variant="h6" color="textPrimary">
            Vas a tener que realizar la denuncia policial en la comisaría
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <List aria-label="detalles">
          <ListItem>
            <ListItemIcon>
              <OkIcon />
            </ListItemIcon>
            <ListItemText
              disableTypography
              primary={
                <Typography variant="body2">
                  Acercate a la comisaría luego de cargar la denuncia, un asesor
                  te la va a pedir más adelante.
                </Typography>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <OkIcon />
            </ListItemIcon>
            <ListItemText
              disableTypography
              primary={
                <Typography variant="body2">
                  Si ya efectuaste la denuncia, ¡te pedimos que le saques una
                  foto!
                </Typography>
              }
            />
          </ListItem>
        </List>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Box m={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => selectComplaint(true)}
            >
              Subir foto de la denuncia
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box m={2}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => selectComplaint(false)}
            >
              Aún no realicé la denuncia
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ComplaintValidation;
